export default __webpack_public_path__ + "static/media/233.2fc81c53.svg";